import { z } from "zod";

export const productReportGroupingSchema = z.enum(["product_id", "asin", "parent_asin_defaulted"]);

export type ProductReportGrouping = z.infer<typeof productReportGroupingSchema>;
